// In-memory store backed by the pure reducer. Used until Phase 3 swaps in SupabaseStore.
import type { Action, AppState } from '../types';
import { initialState, reducer } from '../state/reducer';
import type { Store, SystemStatus } from './Store';

const MOCK_STATUS: SystemStatus = {
  realtime: 'disabled',
  schemaVersionMismatch: null,
  lastError: null,
};

export function createMockStore(initial: AppState = initialState): Store {
  let state = initial;
  const listeners = new Set<() => void>();

  return {
    kind: 'mock',
    getState: () => state,
    dispatch: (action: Action) => {
      const next = reducer(state, action);
      if (next === state) return;
      state = next;
      listeners.forEach((l) => l());
    },
    subscribe: (listener: () => void) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    getSystemStatus: () => MOCK_STATUS,
    clearLastError: () => {
      // Mock has no errors to clear.
    },
  };
}
